import { render, staticRenderFns } from "./Testsheethdxq.vue?vue&type=template&id=4a9b04a4&scoped=true"
import script from "./Testsheethdxq.vue?vue&type=script&lang=js"
export * from "./Testsheethdxq.vue?vue&type=script&lang=js"
import style0 from "./Testsheethdxq.vue?vue&type=style&index=0&id=4a9b04a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b04a4",
  null
  
)

export default component.exports